import React from "react";

import { useStockPageOptional } from "../lib/StockPage";
import withQuoteData from "./withQuoteData";

/**
 * Injects `stockBasicInfo` (with quote-based capitalization).
 * Prefers an explicit `stock` StockPayload prop; otherwise reads from StockPageProvider.
 */
export default function withStockBasicInfo(WrappedComponent) {
  @withQuoteData(false, props => props.stock?.stock?.id)
  class WithStockBasicInfo extends React.Component {
    getBasicInfo() {
      const defaultBasicInfo = {};
      const { stock, quoteData } = this.props;
      const hasBasicInfo = typeof stock?.stock?.basic_info === "object";

      if (hasBasicInfo) {
        const basicInfo = stock.stock.basic_info;
        const { share_amount } = basicInfo || {};
        const { close } = quoteData || {};
        const capitalization = Math.round(share_amount * close);
        return isNaN(capitalization)
          ? basicInfo
          : { ...basicInfo, capitalization };
      }

      return defaultBasicInfo;
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          stockBasicInfo={this.getBasicInfo()}
        />
      );
    }
  }

  function WithStockBasicInfoFromContext(props) {
    const stockPage = useStockPageOptional();
    const stock = props.stock ?? stockPage?.stock?.data ?? null;

    return <WithStockBasicInfo {...props} stock={stock} />;
  }

  return WithStockBasicInfoFromContext;
}
